import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";
import NavBar from "./NavBar";
import TopBar from "./TopBar";

const StyledDashboard = styled("Box")(({ theme }) => ({
  "& .wrapper": {
    flex: "1 1 auto",
    overflow: "hidden",
    minHeight: "calc(100vh - 80px)",
    backgroundColor: theme.palette.background.darkgrey,
    paddingLeft: 250,
    "@media(max-width:900px)": {
      paddingLeft: 0,
    }
  },
}));

const DashboardLayout = ({ children }) => {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const MobileNavOpen = useCallback(() => {
    setMobileNavOpen(false)
  }, []);
  return (
    <>
      <StyledDashboard>
        <div className="root">
          <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
          <NavBar
            onMobileClose={MobileNavOpen}
            openMobile={isMobileNavOpen}
          />
          <div className="wrapper">
            <div className="contentContainer">
              <div className="content" id="main-scroll">
                {children}
              </div>
            </div>
          </div>
        </div>
      </StyledDashboard>
    </>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
